import { useState, useEffect, useCallback } from "react";
import { FolderOpen, FileText, ImageIcon, Upload } from "lucide-react";
import api, { apiErr, fileUrl } from "../lib/api";
import { PageHeader, Loading, Empty, Pill, Stamp } from "../components/kit";
import { Button } from "../components/ui/button";
import { DOC_CATEGORIES, titleCase } from "../lib/constants";
import { toast } from "sonner";

export default function Documents() {
  const [files, setFiles] = useState(null);
  const [cat, setCat] = useState("");

  const load = useCallback(async () => { const { data } = await api.get("/files"); setFiles(data); }, []);
  useEffect(() => { load(); }, [load]);

  const upload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file); fd.append("category", "Other");
    try { await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Uploaded"); load(); }
    catch (err) { toast.error(apiErr(err)); }
  };

  if (!files) return <Loading />;
  const filtered = cat ? files.filter((f) => f.category === cat) : files;

  return (
    <div className="animate-fade-up">
      <PageHeader title="Documents" subtitle="Secure vault for contracts, disclosures, photos, and correspondence." testid="documents-header"
        actions={<label><Button className="bg-navy-800 hover:bg-navy-700 text-white pointer-events-none"><Upload className="w-4 h-4 mr-1.5" />Upload</Button><input type="file" className="hidden" onChange={upload} data-testid="upload-doc-btn" /></label>} />

      <div className="flex flex-wrap gap-2 mb-6">
        <button onClick={() => setCat("")} className={`px-3.5 py-1.5 rounded-lg text-sm ${!cat ? "bg-navy-800 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>All</button>
        {DOC_CATEGORIES.map((c) => <button key={c} onClick={() => setCat(c)} className={`px-3.5 py-1.5 rounded-lg text-sm ${cat === c ? "bg-navy-800 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>{c}</button>)}
      </div>

      {filtered.length === 0 ? <Empty title="No documents" subtitle="Upload contracts, disclosures, and files." /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="documents-grid">
          {filtered.map((f) => (
            <a key={f.id} href={fileUrl(f.id)} target="_blank" rel="noreferrer" className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-gold/40 transition-[box-shadow,border-color] overflow-hidden">
              <div className="h-32 bg-slate-50 flex items-center justify-center">
                {f.is_image ? <img src={fileUrl(f.id)} alt="" className="w-full h-full object-cover" /> : <FileText className="w-10 h-10 text-slate-300" />}
              </div>
              <div className="p-3"><p className="text-sm font-medium text-navy-800 truncate">{f.original_filename}</p><div className="flex items-center justify-between mt-1"><Pill className="text-[10px]">{f.category}</Pill><span className="text-[10px] text-slate-400">{Math.round((f.size || 0) / 1024)}KB</span></div>
                <div className="mt-2 pt-2 border-t border-slate-100 overflow-hidden"><Stamp prefix="Uploaded by" by={f.uploaded_by_name || "System"} at={f.created_at} className="!whitespace-normal" testid={`file-stamp-${f.id}`} /></div></div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
